<template>
  <q-select
    v-model="selectPastSdf"
    :options="props.options"
    outlined
    dense
    clearable
    emit-value
    map-options
    style="background: var(--q-white)"
  >
    <template #no-option>
      <q-item>
        <q-item-section class="text-grey"> 該当するSDFileはありません </q-item-section>
      </q-item>
    </template>
    <template #default>
      <div v-if="!selectPastSdf" style="position: absolute; top: 10px">
        <span class="text-dark">選択してください</span>
      </div>
    </template>
  </q-select>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  options: {
    label: string;
    value: string;
  }[];
  pastSdf: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['selectPastSdf']);

// 過去SDF選択値
const selectPastSdf = computed({
  get: () => props.pastSdf,
  set: (value) => {
    emit('selectPastSdf', value || '');
  },
});
</script>
